
export const isExecutive = (session) => {
    if (!session || !session.department) {
        return false;
    }
    const department = session.department.toLowerCase();
    return department === "executive"
}

export const isFulfillment = (session) => {
    if (!session || !session.department) {
        return false;
    }
    const department = session.department.toLowerCase();
    return department === "fulfillment"
}

export const setPermissions = (session) => {
    // set a permission table for the session
    return;
}

export const checkPerm = (session, role) => {
    if (!session || !session.permissions) {
        return false;
    }
    return session.permissions[role] === 1;
}

// test if an id matches this session's user id
export const matchSession = (session, id) => {
    if (!session) {
        return false;
    }
    return session.id === id;
}